import { UniformSlot } from "@uniformdev/canvas-react";

import { WidthNames } from "@atlaskit/modal-dialog/dist/types/internal/constants";

import {
    ModalLink,
    ModalLinkProps
} from "@/libraries/design/components/modal/src/modal-link";

interface UniformModalProps extends ModalLinkProps {
    modalSize?: WidthNames;
    modalLinkType?: "modal" | "video";
}

// Pass modalSize as the width directly to the Modal component
const UniformModal = (props: UniformModalProps) => {
    return (
        <ModalLink
            modalTitle={props.modalTitle}
            modalCloseLabel={props.modalCloseLabel}
            ctaText={props.ctaText}
            modalWidth={props.modalSize}
            modalLinkType={props.modalLinkType}
            modalDataEventProps={{
                "data-product-key": "uniform",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "modal"
            }}
        >
            <UniformSlot name="modalContent" />
        </ModalLink>
    );
};

export default UniformModal;
